// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"cf50d80b","93":"6ec34d15","271":"3671ebd4","486":"abd79753","501":"f4af6acb","559":"e9821542","604":"492a51c1","671":"59d1ec79","805":"3e4148c7","835":"1c5f344f","909":"61bc6698","920":"587580f2"}[chunkId] + ".chunk.js";
};